import Application from "../../Application";
import GetAllLegalViewTypesInteractor from "../../legalViews/interactor/GetAllLegalViewTypesInteractor";
import OrganisationLegalViewTypesPresenter, {
  IOrganisationLegalViewTypesPresenter
} from "../presenter/OrganisationLegalViewTypesPresenter";
import GetAllOrganisationIndexCategoriesInteractor from "./GetAllOrganisationIndexCategoriesInteractor";
import GetOrganisationLegalViewTypesInteractor from "./GetOrganisationLegalViewTypesInteractor";

export default class ShowOrganisationLegalViewTypesInteractor {
  private application: Application;
  private output?: IOrganisationLegalViewTypesPresenter;
  private getOrganisationLegalViewTypesInteractor: GetOrganisationLegalViewTypesInteractor;
  private getAllOrganisationIndexCategoriesInteractor: GetAllOrganisationIndexCategoriesInteractor;
  private getAllLegalViewTypesInteractor: GetAllLegalViewTypesInteractor;

  constructor({
    application,
    getOrganisationLegalViewTypes,
    getAllLegalViewTypes,
    getAllOrganisationIndexCategories
  }) {
    this.application = application;
    this.getOrganisationLegalViewTypesInteractor =
      getOrganisationLegalViewTypes;
    this.getAllOrganisationIndexCategoriesInteractor =
      getAllOrganisationIndexCategories;
    this.getAllLegalViewTypesInteractor = getAllLegalViewTypes;
  }
  private async getAllOrganisationLegalViewTypes(organisationId) {
    return this.getOrganisationLegalViewTypesInteractor.execute(organisationId);
  }

  private async getAllLegalViewTypes() {
    return this.getAllLegalViewTypesInteractor.execute();
  }
  private async getAllOrganisationIndexCategories(organisationId) {
    return this.getAllOrganisationIndexCategoriesInteractor.execute(
      organisationId
    );
  }

  private async getReferenceLists(organisationId) {
    return Promise.all([
      this.getAllLegalViewTypes(),
      this.getAllOrganisationIndexCategories(organisationId),
      this.getAllOrganisationLegalViewTypes(organisationId)
    ]);
  }

  execute(organisationId: number) {
    this.output = OrganisationLegalViewTypesPresenter({
      application: this.application,

      initialState: {
        organisationLegalViewTypes: [],
        organisationId,
        modalVisible: false,
        currentLegalViewTypeId: undefined,
        legalViewTypes: [],
        codeList: [],
        organisationIndexCategories: [],
        legalViewTypeIndexCategories: [],
        assignTypesToOrganisationModalVisible: false
      }
    });

    this.getReferenceLists(organisationId).then(
      ([
        legalViewTypes,
        organisationIndexCategories,
        organisationLegalViewTypes
      ]) => {
        this.output?.loadReferenceValues(
          organisationId,
          organisationIndexCategories,
          legalViewTypes,
          organisationLegalViewTypes
        );
      }
    );

    return this.output;
  }
}
